module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("id0qp"))).then(() => parcelRequire('f4eak'));